module.exports = __webpack_public_path__ + "html/bd-overlay-preloader.template.html";